import type { ReactNode } from "react";

import { Button } from "./Button";

export function ClientSetupShell({ canSave, children, formId, saving, title, onBack }: {
  canSave: boolean;
  children: ReactNode;
  formId: string;
  saving: boolean;
  title: string;
  onBack(): void;
}) {
  return (
    <section className="sbx-app record-setup-shell" aria-labelledby="record-setup-title">
      <header className="record-setup-header">
        <a className="record-setup-back" href="/clients" onClick={(event) => { event.preventDefault(); onBack(); }}><span aria-hidden="true">←</span><span>Back to clients</span></a>
        <h1 id="record-setup-title">{title}</h1>
        <div className="record-setup-actions">
          <span id="client-save-reason" className="visually-hidden">{canSave ? "Client identity is ready." : "Enter the client or business name to enable Save client."}</span>
          <Button type="button" variant="quiet" onClick={onBack}>Cancel</Button>
          <Button type="submit" variant="primary" form={formId} loading={saving} disabled={!canSave} aria-describedby="client-save-reason">Save client</Button>
        </div>
      </header>
      <main className="record-setup-main sbx-register-layout">{children}</main>
    </section>
  );
}
